import { useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";

function LogoutPage() {

    const { logout } = useContext(AuthContext);

    useEffect(() => {
        logout();
    }, [])

    return(
        <>
            <h1>Logging Out...</h1>
        </>
    );
}
export default LogoutPage;